import { INDEX_REGROUPEMENT_MANUEL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default function genererLigneFaceAjouterOt(tfs, societe, annonceur) {
  if (!tfs) return null;
  let pose = '';
  if (annonceur.indexRegroupement === INDEX_REGROUPEMENT_MANUEL
      && !annonceur.devisCommandeId) {
    pose = annonceur.theme;
  } else {
    pose = annonceur.annonceurs;
    if (annonceur.theme) {
      pose += ' (' + annonceur.theme + ')';
    }
  }
  return {
    produitReference: tfs.produitReference,
    produitId: tfs.produitId,
    affichageId: societe.produitAchatAffichageId,
    commentaireAffichage: null,
    affichage: true,
    grattageId: societe.produitAchatGrattageId,
    grattage: false,
    laisserEnPlaceId: societe.produitAchatLaisserEnPlaceId,
    laisserEnPlace: false,
    restrictionsAffichage: tfs.restrictionsAffichage,
    pose: pose,
    instructionPose: tfs.instructionPose,
    faceId: tfs.faceId,
    materielId: tfs.materielId,
    format: tfs.format,
    materielNbFace: tfs.materielNbFace,
    materielCode: tfs.materielCode,
    materielDisposition: tfs.materielDisposition,
    dispositifId: tfs.dispositifId,
    dispositifCode: tfs.dispositifCode,
    dispositifAdresse: tfs.dispositifAdresse,
    emplacementId: tfs.emplacementId,
    emplacementCode: tfs.emplacementCode,
    ordre: tfs.ordre,
    actionLogistique: annonceur.actionLogistique,
    affichagePrecedent: tfs.affichagePrecedent,
    indexRegroupement: annonceur.indexRegroupement,
    tfsId: tfs.id,
    affectationLogistiqueLigneCommandeId: annonceur.affectationLogistiqueLigneCommandeId,
    affectationLogistiqueProduitId: annonceur.affectationLogistiqueProduitId,
    affectationLogistiqueCommandeId: annonceur.affectationLogistiqueCommandeId,
    ajoutApresCreation: true,
  };
}
